import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    deleteAllGuideInterests,
    deleteAllGuideInterestsVariables,
} from "./__graphql-types__/deleteAllGuideInterests.ts";

export const DELETE_ALL_INTERESTS_MUTATION: GqlOperation<
    deleteAllGuideInterests,
    deleteAllGuideInterestsVariables
> = gqlOp(gql`
    mutation deleteAllGuideInterests($kaid: String!) {
        deleteInterests(kaid: $kaid) {
            error {
                code
                debugMessage
            }
        }
    }
`);
